import { NgModule } from '@angular/core';

import { DeviceImageBehaviorPluginService } from '@shure/shared/angular/device-behavior/plugins/device-image';
import { DeviceImageProvider } from '@shure/shared/angular/ui/components/device-image';

@NgModule({
	// imports: [DeviceBehaviorPluginsModule.forRoot([Mxa920DeviceUiDeviceBehaviorPlugin])],
	providers: [
		{
			provide: DeviceImageProvider,
			useExisting: DeviceImageBehaviorPluginService
		}
	]
})
export class CloudDeviceBehaviorPluginsModule {}
